import script from "./galleryDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./galleryDetail.vue?vue&type=script&setup=true&lang=js"

import "./galleryDetail.vue?vue&type=style&index=0&id=7a727ea2&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a727ea2"]])

export default __exports__